// Client-safe format helpers (no server imports).
// NOTE: generateUniqueJobCode() is server-only (uses Prisma) and lives in the
// backend's src/lib/format.ts. This client version keeps only the pure functions.

const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // no ambiguous chars

export function generateJobCode(): string {
  let code = "DLV-";
  for (let i = 0; i < 5; i++) {
    code += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  }
  return code;
}

// 4-digit delivery confirmation code (revealed to customer, entered by provider).
export function generateConfirmationCode(): string {
  return Math.floor(1000 + Math.random() * 9000).toString();
}

// Phase 2: country-aware currency formatting.
// Defaults to Fdj (Djibouti — the launch market). Somalia uses Sh; ETB is a
// legacy fallback for Ethiopia.
export function currencySymbol(countryCode: string = "+253"): string {
  if (countryCode === "+253") return "Fdj";
  if (countryCode === "+252") return "Sh";
  return "ETB";
}

export function formatPrice(amount: number, countryCode: string = "+253"): string {
  const symbol = currencySymbol(countryCode);
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(amount) + " " + symbol;
}

export function formatRelativeTime(date: string | Date): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const diff = Date.now() - d.getTime();
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return d.toLocaleDateString();
}
